










import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

import Assets from "@/constants/assets.ts";

@Component({
  computed: {
    ...mapGetters({
      mainContainerColor: "getClientMainContainerColor"
    })
  },
  methods: {
    ...mapActions({
      setClientMainContainerColorGreyLight:
        "setClientMainContainerColorGreyLight"
    })
  }
})
export default class ClickBuyLayout extends Vue {
  private assets = Assets;
  private mainContainerColor!: any;
  private setClientMainContainerColorGreyLight!: any;

  private created() {
    this.setClientMainContainerColorGreyLight();
  }

  get backgroundImage() {
    return {
      "background-image": `url("${this.assets.backgroundDecoration}")`,
      "background-repeat": "no-repeat",
      "background-position-x": "left",
      "background-position-y": "23px",
      "background-size": "356px 448px"
    };
  }
}
